module.exports = __webpack_public_path__ + "assets/pictograms/generic_image.cd98520d797e2ce187cf8f1a78165e19.svg";